import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import DashboardComponent from '@/components/Dashboard'
import ItemListComponent from '@/components/ItemList'
import NutriListComponent from '@/components/NutriList'
import SearchComponent from '@/components/Search'
import ItemDetailComponent from '@/components/ItemDetail'
import AboutComponent from '@/components/About'
import InputComponent from '@/components/Input'
import NewComponent from '@/components/New'
import PageNotFound from '@/components/PageNotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: '/items',
      children: [
        // {
        //   path: '/home',
        //   component: DashboardComponent,
        // },
        {
          path: '/items/:category_id?', 
          component: ItemListComponent
        },
        {
          path: '/nutri/:nutri_id?', 
          component: NutriListComponent
        },
        {
          path: '/search/:search', 
          component: SearchComponent
        },
        {
          path: '/item/:id',
          component: ItemDetailComponent,
          props: (route) => ({
            id: route.params.id
          })
        },
        {
          path: '/about',
          component: AboutComponent
        },
        {
          path: '/input',
          component: process.env.NODE_ENV=='development'? InputComponent: PageNotFound
        },
        {
          path: '/new',
          component: process.env.NODE_ENV=='development'? NewComponent: PageNotFound
        }
      ]
    },
    { path: "*", component: PageNotFound }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js